import { ILSTable } from '@common/components';
import { tableOnLateConfig, tableOnLateDateToTable } from '@common/table-configs/monitoring-dashboard/on-late';
import { ColumnTable, Dictionary, IndexedArray, RecordTableButton } from '@common/types';
import { MonitoringOnLateDataModel } from '@common/types/dictionaries/monitoring-vehicle';
import { tableCustom } from '@core/containers/table-custom';
import { MonitoringTableTopLayout } from '@modules/monitoring/children/dashboard/tables/components/monitoring-table-top-layout';
import { showAttachment, useModalDoc } from '@modules/monitoring/hooks/use-modal-view-doc';
import { MonitoringExelData } from '@modules/monitoring/utils/create-exel-data';
import { FC, useState } from 'react';
import { ILSDashboardViewedButtonComponent } from '../../components/viewed-button';
import { addToTableExelButton } from '../../utils/exel-button';
import { addToTableShowViewedButton, hasUnviewed, tableViewedFilter } from '../../utils/viewed-button';
import { useGetWaypointTimeZone } from '@modules/monitoring/hooks/use-get-timezone';
import { useFocusRow } from '@components/data-display/table/hooks/row/use-focus-row';

interface IProps {
  dataSource: Array<MonitoringOnLateDataModel> | IndexedArray<MonitoringOnLateDataModel>;
  onContextOpen?: (record: MonitoringOnLateDataModel, e: MouseEvent) => void;
  columns: ColumnTable<MonitoringOnLateDataModel>[];
  recordTableButtons?: Array<RecordTableButton>;
  loadExel: (exelData: MonitoringExelData | undefined, fileName: string) => void;
  handleUpdateView?: ((id: string | number | string[] | number[], value: 0 | 1) => void) | undefined;
}

// Контейнер таблицы доставлено с опозданием
export const MonitoringTableDeliveryOnLate: FC<IProps> = ({
  dataSource,
  recordTableButtons,
  loadExel,
  onContextOpen,
  handleUpdateView,
  ...props
}) => {
  const [showAll, setShowAll] = useState(true);
  const { DocViewModalContent, openFile } = useModalDoc();
  const { getWpTimeZone } = useGetWaypointTimeZone();

  const decoratedData = tableViewedFilter(
    tableOnLateDateToTable({ dataSource, handleView: handleUpdateView, showAttachment: showAttachment({ openFile }), getWpTimeZone }),
    showAll
  );
  recordTableButtons = addToTableExelButton(recordTableButtons, loadExel, decoratedData, props.columns, Dictionary.OnLate);
  recordTableButtons = addToTableShowViewedButton(recordTableButtons, showAll, (val: boolean) => showAll !== val && setShowAll(val));
  const { setFocusRow, focusRow } = useFocusRow();

  return (
    <MonitoringTableTopLayout>
      <ILSTable
        {...props}
        setFocusRow={setFocusRow}
        focusRow={focusRow}
        recordTableButtons={recordTableButtons}
        config={tableOnLateConfig}
        dataSource={decoratedData}
        size={'small'}
        pagination={false}
        scroll={{ y: 'calc(75vh - 430px)' }}
        className="editable-table"
        bordered
        dictionary={Dictionary.OnLate}
        onContextOpen={onContextOpen}
      />
      <ILSDashboardViewedButtonComponent
        key={Dictionary.OnLate + 'button'}
        disabled={!hasUnviewed(decoratedData)}
        onClick={() => {
          handleUpdateView?.(
            tableViewedFilter(decoratedData, false).map((item) => item.ID.toString()),
            1
          );
        }}
      />
      {DocViewModalContent}
    </MonitoringTableTopLayout>
  );
};

export const ILSMonitoringOnLate = tableCustom(MonitoringTableDeliveryOnLate, tableOnLateConfig, Dictionary.OnLate);
